<template>
  <div>
    <div class="content">
      <div class="title-box">
        <h3>{{multiLanguage.text}}</h3>
      </div>
      <div class="panel" element-loading-spinner="el-icon-loading" v-loading="loading">
        <mtable
          :back="back"
          :downLoadTran="downLoadTran"
          :firstTh="firstTh"
          :jsonExcelAjax="jsonExcelAjax"
          :link="link"
          :multiExcelAjax="multiExcelAjax"
          :multiLanguage="multiLanguage"
          :name="name"
          :page="page"
          :region="curArea"
          :secondTh="secondTh"
          :selPage="selPage"
          :thData="thData"
          :trData="trData"
          @seek="tableAjax"
          @tableChange="tableAjax"
          v-if="trData"
        >
          <div class="slotDiv" slot="handle">
            <div class="selectDiv">
              <span>{{multiLanguage.typeText}}</span>
              <el-select @change="searchData" style="width:105px" v-model="realTime.type">
                <el-option
                  :key="key"
                  :label="val"
                  :value="key"
                  v-for="(val, key) in multiLanguage.typeList"
                ></el-option>
              </el-select>
            </div>
            <div class="inputDiv">
              <div class="searchDiv">
                <span>{{multiLanguage.start_time}}</span>
                <el-date-picker
                  :placeholder="multiLanguage.selectTimeText"
                  style="width: 200px"
                  type="datetime"
                  v-model="realTime.start_time"
                ></el-date-picker>
              </div>
              <div class="searchDiv">
                <span>{{multiLanguage.end_time}}</span>
                <el-date-picker
                  :placeholder="multiLanguage.selectTimeText"
                  style="width: 200px"
                  type="datetime"
                  v-model="realTime.end_time"
                ></el-date-picker>
              </div>
              <div class="btnDiv">
                <el-button @click="searchData" type="primary">{{multiLanguage.search}}</el-button>
              </div>
            </div>
          </div>
          <div class="extraSearch" slot="title-name">
            <div class="moreSelect">
              <el-switch :active-text="multiLanguage.moreSelect" inactive-text v-model="more"></el-switch>
            </div>
            <div class="searchDiv">
              <span>{{multiLanguage.IB_ID}}</span>
              <el-input style="width: 200px;" v-model="realTime.IB_ID"></el-input>
            </div>
            <div class="searchDiv">
              <span>{{multiLanguage.deposit_order_id}}</span>
              <el-input style="width: 200px" v-model="realTime.deposit_order_id"></el-input>
            </div>
            <div class="searchDiv" v-show="more">
              <span>{{multiLanguage.clientAccount}}</span>
              <el-input style="width: 200px;" v-model="realTime.client_account"></el-input>
            </div>
            <div class="searchDiv" v-show="more">
              <span>{{multiLanguage.mtlogin}}</span>
              <el-input style="width: 200px;" v-model="realTime.mtlogin"></el-input>
            </div>
            <div class="searchDiv" v-show="more">
              <span>{{multiLanguage.symbol}}</span>
              <el-input style="width: 200px;" v-model="realTime.symbol"></el-input>
            </div>
            <div class="searchDiv" v-show="more">
              <span>{{multiLanguage.trade_order_id}}</span>
              <el-input style="width: 200px;" v-model="realTime.trade_order_id"></el-input>
            </div>
            <div class="searchDiv" v-show="more">
              <span>{{multiLanguage.depositAccount}}</span>
              <el-input style="width: 200px;" v-model="realTime.depositAccount"></el-input>
            </div>
          </div>
        </mtable>
      </div>
    </div>
  </div>
</template>
<script>
import mtable from '../../comm/mytable'
import { formatDate } from 'common/js/util'
import { URL_REALTIME } from 'api/commissionApi'
import { Api } from 'api/commissionEnv'
let api = new Api()

export default {
  name: 'realTimeResult',
  mixins: [require('common/mixin/base.js').base({ multiLanguage: 'realTimeReport' }), require('common/mixin/base.js').base({ publicLan: 'publicLan' })],
  props: ['curArea'],
  data() {
    return {
      trData: [],
      url: '',
      loading: true,
      realTime: {
        type: '-1',
        IB_ID: '',
        deposit_order_id: '',
        start_time: new Date(new Date().getTime() - 7 * 24 * 36e5),
        end_time: '',
        client_account: '',
        symbol: '',
        trade_order_id: '',
        mtlogin: '',
        depositAccount: ''
      },
      link: {
        key: ['AMOUNT'],
        path: '/ib_v2/realTimeDetailResult'
      },
      page: {
        // 分页
        active: 1,
        pageLeng: 0
      },
      selPage: {
        //  配合分页的显示col数目选择
        list: [5, 10, 25, 50],
        active: localStorage.pageMaxIndex,
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      },
      more: false
    }
  },
  mounted() {
    if (sessionStorage.getItem('back')) {
      let backObj = JSON.parse(sessionStorage.getItem('back'))
      if (backObj.path === 'realTimeResult') {
        this.realTime.symbol = backObj.symbol
        this.realTime.trade_order_id = backObj.trade_order_id
        this.realTime.client_account = backObj.client_account
        this.realTime.mtlogin = backObj.mtlogin
        this.realTime.depositAccount = backObj.depositAccount
        this.realTime.type = backObj.type
        this.realTime.IB_ID = backObj.id
        this.realTime.deposit_order_id = backObj.report_id
        this.realTime.start_time = backObj.beginTime
        this.realTime.end_time = backObj.endTime
        this.page.active = backObj.pageNum + 1
        this.selPage.limit = backObj.pageSize
        this.more = backObj.more
      }
      this.tableAjax()
      sessionStorage.removeItem('back')
    } else {
      this.tableAjax()
    }
  },
  methods: {
    searchData() {
      this.page.active = 1
      this.tableAjax()
    },
    tableAjax() {
      const checkParams = ['trade_order_id', 'IB_ID', 'client_account', 'mtlogin', 'depositAccount', 'deposit_order_id'].every(v => {
        const r = /^\d{0,}$/.test(this.realTime[v])
        if (!r) this.$message.error(`${this.multiLanguage[v].replace(/：/, '')}${this.publicLan.notNumber}`)
        return r
      })
      if (!checkParams) return
      
      this.loading = true
      this.url = api.getUrl20(this.curArea,URL_REALTIME)
      let obj = {
        params: {
          symbol: this.realTime.symbol,
          trade_order_id: this.realTime.trade_order_id,
          client_account: this.realTime.client_account,
          mtlogin: this.realTime.mtlogin,
          depositAccount: this.realTime.depositAccount,
          type: this.realTime.type,
          id: this.realTime.IB_ID,
          report_id: this.realTime.deposit_order_id,
          beginTime: formatDate(this.realTime.start_time),
          endTime: formatDate(this.realTime.end_time),
          pageNum: this.page.active - 1,
          pageSize: this.selPage.limit
        }
      }
      this.getIbReportDatas(this.url, obj)
    },
    getIbReportDatas(url, obj) {
      this.$http.get(url, obj).then(res => {
        this.trData = res.data.data.data
        this.page.pageLeng = res.data.data.count
        this.setOfficeState()
        this.loading = false
      })
    },
    setOfficeState() {
      let list = this.multiLanguage.typeList
      if (Object.prototype.toString.call(this.trData) == '[object Array]') {
        this.trData.forEach((item, index) => {
          let temp = this.trData[index]
          temp.type = temp.TYPE || temp.TYPE == 0 ? list[+temp.TYPE] : ''
        })
      }
    }
  },
  computed: {
    back() {
      return JSON.stringify({
        path: 'realTimeResult',
        symbol: this.realTime.symbol,
        trade_order_id: this.realTime.trade_order_id,
        client_account: this.realTime.client_account,
        mtlogin: this.realTime.mtlogin,
        depositAccount: this.realTime.depositAccount,
        type: this.realTime.type,
        id: this.realTime.IB_ID,
        report_id: this.realTime.deposit_order_id,
        pageNum: this.page.active - 1,
        pageSize: this.selPage.limit,
        beginTime: this.realTime.start_time,
        endTime: this.realTime.end_time,
        more: this.more
      })
    },
    name() {
      return this.multiLanguage.text
    },
    downLoadTran() {
      return { TYPE: this.multiLanguage.typeList }
    },
    thData() {
      return this.multiLanguage.realTimeTh_v2
    },
    jsonExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data', 'data'],
        ajaxPar: {
          pageSize: this.page.pageLeng,
          pageNum: 0,
          symbol: this.realTime.symbol,
          trade_order_id: this.realTime.trade_order_id,
          client_account: this.realTime.client_account,
          mtlogin: this.realTime.mtlogin,
          depositAccount: this.realTime.depositAccount,
          type: this.realTime.type,
          id: this.realTime.IB_ID,
          report_id: this.realTime.deposit_order_id,
          beginTime: formatDate(this.realTime.start_time),
          endTime: formatDate(this.realTime.end_time)
        }
      }
    },
    firstTh() {
      let nweArray = this.multiLanguage.detailTh_v2.slice()
      const obj = {
        th: {},
        TYPE: this.multiLanguage.detailType
      }
      for (let index = 1; index < 4; index++) nweArray.splice(index + 1, 0, this.multiLanguage.extraHead[index])
      for (let v of nweArray) obj['th'][v.key.toLocaleUpperCase()] = v.name
      return obj
    },
    secondTh() {
      let nweArray = this.multiLanguage.extraHead.concat(this.multiLanguage.lowerLevel)
      let obj = {
        th: {},
        RULE_ID: this.publicLan.rule,
        PRODUCT_GROUP: this.publicLan.products
      }
      for (let v of nweArray) {
        obj['th'][v.key.toLocaleUpperCase()] = v.name
      }
      return obj
    },
    multiExcelAjax() {
      return {
        url: this.url,
        ajaxType: 'get',
        getKey: ['data', 'data'],
        dataTh: true,
        filter: {
          columns: ['client_account', 'mtlogin'],
          btnName: this.multiLanguage.downloadFilterExcel,
          errorMsg: this.multiLanguage.errorMsg,
          mapping: { client_account: 'CLIENT_ID', mtlogin: 'TRADING_ACCOUNT_ID' },
          filterDownloadName: this.multiLanguage.filterName
        },
        ajaxPar: {
          detail: 'true',
          pageSize: this.page.pageLeng,
          pageNum: 0,
          symbol: this.realTime.symbol,
          trade_order_id: this.realTime.trade_order_id,
          client_account: this.realTime.client_account,
          mtlogin: this.realTime.mtlogin,
          depositAccount: this.realTime.depositAccount,
          type: this.realTime.type,
          id: this.realTime.IB_ID,
          report_id: this.realTime.deposit_order_id,
          beginTime: formatDate(this.realTime.start_time),
          endTime: formatDate(this.realTime.end_time)
        }
      }
    }
  },
  watch: {
    multiLanguage() {
      this.setOfficeState()
    },
    curArea(newVal, oldVal) {
      this.realTime.type = '-1'
      this.realTime.IB_ID = ''
      this.realTime.deposit_order_id = ''
      this.realTime.mtlogin = ''
      this.realTime.depositAccount = ''
      this.realTime.start_time = new Date(new Date().getTime() - 7 * 24 * 36e5)
      this.realTime.end_time = ''
      this.page.active = 1
      this.tableAjax()
    }
  },
  components: {
    mtable
  }
}
</script>

<style lang="scss" type="text/scss" scoped>
.title-box {
  border: 1px solid #3f51b5;
  background: #3f51b5;
  padding: 0 20px;
  color: #fff;
  border-radius: 5px 5px 0 0;
}
.slotDiv {
  float: left;
  .selectDiv {
    float: left;
  }
  .inputDiv {
    float: left;
    margin-left: 10px;
    .searchDiv {
      float: left;
      margin-right: 10px;
    }
    .btnDiv {
      float: left;
      margin-right: 30px;
    }
  }
}
.extraSearch {
  margin-left: 20px;
  .moreSelect {
    float: left;
    margin-right: 50px;
    margin-top: 10px;
    margin-bottom: 30px;
  }
  .searchDiv {
    float: left;
    margin-right: 10px;
    margin-bottom: 20px;
  }
}
</style>




// WEBPACK FOOTER //
// realTimeResult.vue?8f084a28